import { programTypeMapper } from "@tailormed/common-client/util/programTypeMapping";

export function getPotentialSavingMatchedDrugs(potentialSaving, journey) {
  const apDrugNames = potentialSaving.apPossibleDrugs?.map((possibleDrug) => possibleDrug.tmDisplayName);
  const journeyDrugNames = journey.events?.map((event) => event.eventTitle);
  const matchedDrugNames = journeyDrugNames?.filter((journeyDrug) => {
    return apDrugNames?.includes(journeyDrug);
  });

  if (matchedDrugNames?.length) {
    matchedDrugNames.sort((a, b) => a.localeCompare(b));
    return (
      matchedDrugNames
        // Remove duplicate drugs
        .filter((matchedDrug, index, matchedDrugs) => matchedDrugs.indexOf(matchedDrug) === index)
        // Remove generic name from branded display name
        .map((matchedDrug) => matchedDrug.replace(/ \((.*?)\)/i, ""))
        .join(", ")
    );
  }
}

export function getPotentialSavingDisplayName(potentialSaving, journey) {
  const { name } = potentialSaving;
  let displayName = name;
  let drugName;
  const currentApplication = potentialSaving.applications.find((app) => app.id === potentialSaving.currentApplication);

  if (
    programTypeMapper.isManufacturerProgram(potentialSaving) ||
    programTypeMapper.isManufacturerFreeDrugProgram(potentialSaving)
  ) {
    drugName = potentialSaving.drugDisplayName;
  } else if (programTypeMapper.isFoundationProgram(potentialSaving)) {
    if (
      currentApplication &&
      currentApplication.associatedDrugs &&
      (currentApplication.associatedDrugs.length > 1 ||
        (currentApplication.associatedDrugs.length === 1 && currentApplication.associatedDrugs[0] !== ""))
    ) {
      const drugsNames = currentApplication.associatedDrugs.join(", ");
      drugName = drugsNames;
    } else {
      drugName = getPotentialSavingMatchedDrugs(potentialSaving, journey);
    }
  }

  if (drugName && !currentApplication?.hideAssociatedDrugs) {
    displayName = `${name} (${drugName})`;
  }
  return { displayName, drugName };
}
